
import { defineComponent } from "vue"
import CardSeriesIndex from "@/components/card_series/Index.vue"

export default defineComponent({
  components: {
    CardSeriesIndex
  }
})
